import { gql } from '@apollo/client';

export const DELETE_PERIOD_GROUP = gql`
  mutation DeletePeriodGroup($id: ID!) {
    periodGroup: deletePeriodGroup(id: $id) {
      id
    }
  }
`;
